







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Tile extends Vue {
  @Prop() private noData!: boolean;
  @Prop() private isLoading!: boolean;

  get cancelable() {
    return false;
  }
  get scrull() {
    return false;
  }
}
